import script from "./login.vue?vue&type=script&setup=true&lang=js"
export * from "./login.vue?vue&type=script&setup=true&lang=js"

import "./login.css?vue&type=style&index=0&id=5e241d5d&scoped=true&lang=css"
import "./login.vue?vue&type=style&index=1&id=5e241d5d&scoped=true&lang=css"

import exportComponent from "G:\\work\\快创\\不凡商城\\aliyun\\bf-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e241d5d"]])

export default __exports__